import { defineMessages } from 'react-intl';

const messages = defineMessages({
  CreatedOn: 'Created on',
  DocumentDateFrom: 'Document date from',
  DocumentDateUntil: 'Document date until',
  CreatedOnFrom: 'Created on from',
  CreatedOnUntil: 'Created on until',
  ChangeSigningStatus: 'Change signing status',
  InvalidType: 'Invalid type',
  SharePointFileWillBeMovedInBackground: 'The file will be moved to SharePoint in the background',
  SharePointFileMovedInBackground: 'The file has finished moving to SharePoint',
  PrefixFilenameWithDocumentDate: 'Prefix filename with document date',
  GroupByRelation: 'Group by relation',
  OnlyEmailsByAdminPulseCanBeResent: 'E-mails that were not sent by AdminPulse cannot be resent',
  TheMailHasBeenSentAgain: 'The email has been sent again',
  ResendEmail: 'Resend email',
  ResendEmailConfirmationMsg: 'Are you sure you want to resend this email?',
  Share: 'Share',
  MarkAsSigned: 'Mark as signed',
  Template: 'Template',
  CreateRelation: 'Create relation',
  SelectAll: 'Select all',
  UpdateRelation: 'Update relation',
  Download: 'Download',
  MoreFilters: 'More filters',
  SelectYourFilters: 'Select your filters',
  EditDocumentInSharePoint: 'Edit document in SharePoint',
  OpenDocumentInSharePoint: 'Open document in SharePoint',
  DocumentCheckedOut: 'Document is checked out by {name}',
  Forward: 'Forward',
  Open: 'Open',
  LinkToRelation: 'Link to relation',
  DeleteDocument: 'Delete document',
  ShowAllDocumentsForRelation: 'Show documents for relation',
  StartTypingToSearch: 'Start typing to search',
  EmailStatus: 'Email status',
  RemoveEmails: 'Remove e-mails',
  EmailLinkType: 'Email context',
  EmailGlobalActionsTooltip:
    'Select one or more e-mails to execute a global action on these e-mails',
  DropzoneExplanation:
    'AdminPulse will try to identify documents uploaded here and suggest a way to process them.',
  AutoLinkDocumentsToCompanyExplanation:
    'The document will be linked to this company. If new relations are created based on this document, the relations will be linked to this company.',
  DocumentWillBeLinkedToCompanyAutomatically: 'The document will be linked to company {company}.',
  DocumentWillBeLinkedToRelationAutomatically:
    'Documents that you upload here will now be automatically linked to {relation}.',
  Documents: 'Documents',
  Dropzone: 'Dropzone',
  ChooseRelationLinkDocument: 'Choose a relation you want to link {documentName} to.',
  NoDocumentsFound: 'No documents found',
  UploadFilesToCurrentFolder: 'Drop to upload files to current folder',
  UploadFilesToSpecificFolder: 'Drop to upload files to a specific folder',
  MoveOrCopyDocument: 'Drop your document to move or copy it',
  DropDocumentToAddTag: 'Drop your document to add a tag',
  NrOfLinkedRelations: '{nr} relations',
  AllDocumentsSelected: 'All documents selected',
  AllEmailsSelected: 'All emails selected',
  CountEmailsSelected: 'Selected {count} e-mails',
  Name: 'Name',
  Relation: 'Relation',
  Relations: 'Relations',
  Edit: 'Edit',
  CheckoutBrowser: 'Checkout in browser',
  CheckoutApp: 'Checkout in app',
  Checkin: 'Checkin',
  DiscardCheckout: 'Discard checkout',
  DiscardCheckoutAction: 'Discard checkout',
  ContinueEditing: 'Continue editing',
  Type: 'Type',
  Status: 'Status',
  SearchDocuments: 'Search documents',
  IncludeInactiveRelations: 'Include inactive relations',
  AllDocuments: 'All documents',
  DocumentsWithoutTags: 'Without tags',
  AllTags: 'All tags',
  Tags: 'Tags',
  Folders: 'Folders',
  FolderStructure: 'Folder structure',
  WithDocumentTags: 'With document tags',
  WithoutDocumentTags: 'Without document tags',
  CheckinDocument: 'Check in document',
  // Toastrs
  MsgDeleteDocumentSuccess: 'Document deleted',
  MsgDeleteDocumentError: 'Error while deleting document',
  MsgCheckinDocumentError: 'Error while checking in document',
  MsgCheckoutDocumentError: 'Error while checking out document',
  MsgLinkRelationDocumentSuccess: 'Document linked to relation',
  MsgDiscardCheckoutDocumentSuccess: 'Document checkout discarded',
  MsgDiscardCheckoutDocumentError: 'Error while discarding document checkout',
  MsgLinkRelationDocumentError: 'Error while linking document to relation',

  MsgRecognitionDocumentUploadError: 'Error while uploading recognition document',

  MsgMarkSignedLetterSuccess: 'Document marked as signed assignment letter',
  MsgMarkSignedLetterError: 'Error while marking assignment letter as signed',

  MsgCreateRelationSuccess: 'Relation created',
  MsgCreateRelationError: 'Error while creating relation',

  MsgUpdateRelationSuccess: 'Relation updated',
  MsgUpdateRelationError: 'Error while updating relation',
  DocumentDate: 'Document date',
  ReferenceYear: 'Reference year',
  CreationDate: 'Creation date',
  CreatedBy: 'Created by',
  Role: 'Role',

  AmountOfAuthorizations: 'Amount of authorizations',
  AmountOfRelations: 'Amount of relations',
  AmountOfRegistrations: 'Amount of registrations',
  IgnoredColumns: 'Ignored columns',
  UpdateAuthorizations: 'Update authorizations',
  Importregistrationlist: 'Import registrations',
  ExtractZip: 'Extract zip',
  ExtractAndKeep: 'Extract and keep',
  ExtractAndDelete: 'Extract and delete',
  ExtractZipTitle: 'Extract zip',
  ExtractZipMessage: 'Do you want to keep the original zip file or not?',
  ProcessAuthorizationList: 'Process authorization list',
  CreateNewRelations: 'Create relation if it does not exist',
  RemoveExpiredAuthorizations: 'Remove expired authorizations',
  ProcessAuthorizationListQueued:
    'Authorization list will be processed shortly. Click here to view its progress.',
  ProcessRegistrationListQueued:
    'Registration import will be processed shortly. Click here to view its progress.',
  ProcessRegistrationList: 'Process registrations',
  DefaultRegistrationDate: 'Default registration date',
  NotLinkedToARelation: 'Not linked to a relation',
  NotLinkedToARelationShort: 'No relation',
  LinkedToMultipleRelations: 'Linked to multiple relations',
  LinkedToMultipleRelationsShort: 'Multiple relations',
  GlobalActions: 'Global actions',
  DocumentGlobalActionsTooltip:
    'Select one or more documents to execute a global action on these documents.',
  AddOrRemoveTags: 'Add or remove tags',
  Action: 'Action',
  AddTags: 'Add tags',
  RemoveTags: 'Remove tags',
  EnterTag: 'Enter tag',
  GlobalActionStarted: 'Global action was started, click here to see its progress',
  AddOrRemoveRelations: 'Add or remove relations',
  AddRelations: 'Add relations',
  RemoveRelations: 'Remove relations',
  DeleteSingleDocumentConfirmationMsg:
    'Are you sure you want to delete this document? This action cannot be undone.',
  DeleteMultipleDocumentsConfirmationMsg:
    'Are you sure you want to delete these documents? This action cannot be undone.',
  RemoveDocuments: 'Remove documents',
  CheckinDocumentConfirmationMsg:
    'Are you sure you want to discard this checkout? It is currently checked out by {name} so this action may result in a loss of changes.',
  DownloadAsZip: 'Download as zip',
  DownloadZipWithFolderStructureYesNo:
    'Do you want to download the documents in their folder structure? If not, they will be added to the zip as one plain list of documents.',
  CountDocumentsSelected: 'Selected {count} documents',
  SendByEmail: 'Send by email',
  PleaseFilterOnRelationBeforeSendingEmail:
    'Please select a relation before trying to send an email.',
  EmailSent: 'Email sent',
  PleaseMakeManualSelectionOfDocuments:
    'Please make a manual selection of documents that you want to send by email, not using the select-all button.',
  ResetFilters: 'Reset filters',
  DocumentWasMoved: 'The document was moved.',
  SigningStatus: 'Signing status',
  CreateNewToDo: 'Create new to-do',
  DocumentIsPublicOnPortal: 'Document is public on portal',
  EnableOrDisableIsPublicOnPortal: 'Set or remove is public on portal',
  IsPublicOnPortal: 'Is public on portal',
  SendSignatureRequest: 'Send signature request',
  NoDocumentProviderConfigured:
    'No signing provider has been configured. You can configure a document signing provider under general settings.',

  NoSignaturedFoundOnDocument: 'No signature fields were found on the document.',
  Signature: 'Signature',
  Signer: 'Signer',
  Email: 'Email',
  Mobile: 'Mobile',
  ChooseEmployee: 'Choose an employee',
  ChooseClient: 'Choose a client',
  Or: 'Or',
  NoEmailAddress: 'No email address',
  NoPhone: 'No phone',
  SelfSignature: 'Self signature',
  RequiredSignature: 'Signature is required',
  DocumentSigningRequestSent: 'Signature request sent',
  DocumentSigningRequestFailed: 'Signature request failed',
  TheDocumentNeedsToBeLinkedToARelationInOrderToSign:
    'The document needs to be linked to at least 1 relation in order to send a signature request.',
  ChooseRelation: 'Choose relation',
  ClickToAddSignatureFieldsToDocumentOnEmptyPage:
    'Click on the button to start adding signees to the document. The signatures will be placed on an empty page at the end of the document.',
  Success: 'Success',
  Add: 'Add',
  Delete: 'Delete',
  RevokeSignatureRequest: 'Revoke signature request',
  RevokeSignatureRequestConfirmationMsg: 'Are you sure you want to revoke this signature request?',
  SignatureRequestRevoked: 'Signature request revoked',
  LinkedRelations: 'Linked relations',
  LinkedRelationsRequiresRelation: 'Select a relation first to filter by linked relations',
  DocumentCreatedBy: 'Created by',
  NoRelationCandidatesFound:
    'No e-mailaddress or contact with an e-mailaddress was found. Please add an e-mailaddress to the relation, or add a linked relation with an e-mailaddress if the relation is of type company.',
  DeleteRelationLink: 'Delete relation link',
  DeleteRelationLinkConfirmationMsg:
    'Are you sure you want to delete the relation from this document?',
  RelationLinkDeleted: 'Relation link deleted.',
  ChangeDocumentDate: 'Change document date',
  ChangeReferenceYear: 'Change reference year',
  InvalidDate: 'Invalid date',
  SendOn: 'Send on',
  DelayedSendingExplanation: 'If empty, the e-mail will be sent immediately',
  Emails: 'E-mails',
  Attachments: 'Attachments',
  Invoices: 'Invoices',
  IncludeEmailsTooltip: 'Show or hide emails in the document overview',
  IncludeInvoicesTooltip: 'Show or hide invoices in the document overview',
  IncludeAttachmentsTooltip: 'Show or hide attachments in the document overview',
  CreateMergedPdf: 'Create merged PDF',
  Subject: 'Subject',
  EmailTo: 'To',
  From: 'From',
  Cc: 'CC',
  Bcc: 'BCC',
  Date: 'Date',
  ToCcBcc: 'To / CC / BCC',
  SystemEmailsCannotBeRemoved: 'Invoice e-mails that were sent by AdminPulse cannot be removed',
  NoEmailsFound: 'No emails found',
  DocumentWasUploaded:
    'Document uploaded. It will be added to the list when recognition has finished',
  UploadFilesToStartRecognition: 'Upload files to start recognition',
  ColumnConfig: 'Configure columns',
  SelectOverviewColumns: 'Select overview columns',
  DocumentDateWasModified: 'Document date was modified',
  InvalidDocumentDate: 'Invalid document date',
  ClickForAdvancedUpload: 'Click for advanced upload',
  Content: 'Content',
  NoDigitalSigningTemplateFound: 'No digital signing template found',
  ChooseTemplate: 'Choose template',
  OpenEmailTemplates: 'Open email templates',
  Templates: 'Templates',
  AddSigner: 'Add signer',
  RequiredEmailBodyAndSubject: 'Email body and subject are required',
  Signers: 'Signers',
  DownloadAsPdf: 'Download as pdf',
  RepresentativeOfRelation: '(representative of {relation})',
  SendViaEmail: 'Send via e-mail',
  SendAsPdf: 'Send PDF via e-mail',
  SelectRelation: 'Select relation',
  DocumentCouldNotBeConverted: 'Document could not be converted',
  OneOrMoreOfTheDocumentsCannotBeSigned: 'OneOrMoreOfTheDocumentsCannotBeSigned',
  Success: 'Success',
  Reply: 'Reply',
  ReplyAll: 'Reply all',
  MoveToSharepoint: 'Move to sharepoint',
  LinkToSharepointLocation: 'Link to sharepoint location',
  LinkFromSharepoint: 'Link from sharepoint',
  Save: 'Save',
  OpenInApp: 'Open in app',
  SharepointSite: 'Sharepoint site',
  SharepointDrive: 'Sharepoint drive',
  Folder: 'Folder',
  File: 'File',
  SharepointFileSuccessfullyMoved: 'Successfully moved file to sharepoint.',
  CheckedOutSuccesfull: 'Successfully checked out file.',
  Duplicate: 'Duplicate',
  ChangeDocumentType: 'Change type',
  Replace: 'Replace',
  ForcedRelationModeCancelledMessage:
    'This modal will appear every time you open the document screen. If this is bothering you, you need to assign a relation to every document.',
  CheckedOutDocumentsReminderMessage:
    'This modal will appear every time you open the document screen if you have documents that have been checked out for longer than a day.',
  CheckedOutUser: 'Checked out by',
  ExtractDocumentData: 'Extract data (AI)',
  ExtractingDocumentData: 'Extracting data...',
  DocumentDataExtracted: 'Data extracted successfully',
  DocumentDataExtractionFailed: 'Failed to extract data',
  DocumentDataExtractionStarted: 'Data extraction started',
  DocumentDataExtractionInsufficientData:
    'Not enough data found in the document to continue processing',
  DocumentDataExtractionUnsupportedType: 'This document type is not supported for AI extraction',
  ExtractDataWithAI: 'Extract data with AI',
  ConfirmExtractDataWithAI: 'Extract data with AI',
  ConfirmExtractDataWithAIMessage:
    'This action will use AI credits to extract data from the selected documents. Do you want to continue?',
  NoRelationForExtraction: 'Please link a relation to this document before extracting data',
  ExtractionInProgress: 'Data extraction in progress',
  ExtractionCompleted: 'Data already extracted',
  ExtractionFailed: 'Extraction failed - click to retry',
});

export default messages;
